import moment from 'moment';
import React from 'react';
import Avatar from '../components/Avatar';
import type { DocumentType } from '../graphql/generated/gql';
import { gql } from '../graphql/generated/gql';
import { useGetUser } from '../user/useAllUsers';
import Link from '../utils/router/Link';
import userPath from '../utils/url/userPath';
import yearSensitiveDateString from '../utils/yearSensitiveDateString';
import * as styles from './VerificationEntry.module.scss';

const VERIFICATION_ENTRY_FRAGMENT = gql(`
  fragment VerificationEntry_verificationEntry on VerificationEntry {
    verifiedAt
    expiredAt
    verifier {
      ...useGetUser_user
    }
  }
`);

interface VerificationEntryProps {
  verificationEntry: DocumentType<typeof VERIFICATION_ENTRY_FRAGMENT>;
}

const VerificationEntry = ({
  verificationEntry: { verifiedAt, expiredAt, verifier },
}: VerificationEntryProps) => {
  const getUser = useGetUser();
  const fullUser = getUser(verifier);

  return (
    <div className={styles.container}>
      <Link to={userPath(fullUser)} className={styles.verifier}>
        <div>
          <Avatar user={fullUser} size={24} />
        </div>
        <div className={styles.verifierName}>{fullUser.name}</div>
      </Link>
      <div className={styles.dateRange}>
        {yearSensitiveDateString(verifiedAt, 'MMM D', expiredAt)} -{' '}
        {moment(expiredAt).format('MMM D, YYYY')}
      </div>
    </div>
  );
};

export default VerificationEntry;
